// extracted by mini-css-extract-plugin
export default {"container":"Card-module--container--s9oGi","amountContainer":"Card-module--amount-container--QOVtJ","disabled":"Card-module--disabled--69Ede","image":"Card-module--image--A020O"};